import Swiper from 'swiper';

class ArchiveMot {
  private container: HTMLElement | null;
  private header: HTMLElement | null;
  private triggers: NodeListOf<HTMLElement>;


  constructor() {
    this.container = document.querySelector('.archive-mot')
    this.header = document.querySelector('header');
    this.triggers = document.querySelectorAll('[data-archive-mot-target]');

    if (!this.container)
      return
    this.initSwiper();
    this.setupClickListeners();
    this.handlePageLoadScroll();

  }

  private initSwiper(): void {
    new Swiper('.archive-mot__swiper', {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      preventInteractionOnTransition: true,
    });
  }

  private setupClickListeners(): void {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = trigger.dataset.archiveMotTarget;
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          this.scrollToTarget(targetElement);
        }
      });
    });
  }


  private handlePageLoadScroll(): void {
    const hash = window.location.hash.substring(1);
    if (!hash) return;

    const targetElement = document.querySelector<HTMLElement>(`[data-archive-mot-mot="${hash}"]`);

    if (targetElement) {
      setTimeout(() => {
        this.scrollToTarget(targetElement);

        const card = targetElement.querySelector<HTMLElement>('.card-mot summary');
        card?.click();
      }, 100);
    }
  }

  private scrollToTarget(targetElement: HTMLElement): void {
    if (!this.header) return;

    const headerHeight = this.header.offsetHeight;
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    const scrollTargetY = targetPosition - headerHeight;

    window.scrollTo({
      top: scrollTargetY,
      behavior: 'smooth'
    });
  }
}

export const archiveMot = new ArchiveMot();
